import HomeViewTemp from './HomeViewTemp'

export default HomeViewTemp
